import { Link } from "react-router-dom";
import { Button } from "@blueprintjs/core";
import { Trans } from "react-i18next";

export default function DeviceSettingsButton(props) {
  return (
    <Link
      to={`/device/${props?.general?.server}/${props?.general?.id}/settings`}
      style={{ textDecoration: "none", color: "inherit" }}
    >
      <Button icon="wrench" text={<Trans>device configuration</Trans>} />
    </Link>
  );
}
